module.exports = __webpack_public_path__ + "img/CBRE.a730eebe.jpg";